import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["form"]

  declare readonly formTarget: HTMLElement
  declare readonly hasFormTarget: boolean

  toggle(): void {
    if (this.hasFormTarget) {
      this.formTarget.classList.toggle("hidden")
    }
  }
}
